import { render, staticRenderFns } from "./ResetAllText.vue?vue&type=template&id=6bb81999&scoped=true&"
import script from "./ResetAllText.vue?vue&type=script&lang=js&"
export * from "./ResetAllText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb81999",
  null
  
)

export default component.exports